{
  "metadata": {
    "titulo": "Comparativo de asistencia - Comité Central 2024, 2025 y 2026",
    "fuente": "Comparativo_asistencia_Comite_Central_PDF_2024_2026.xlsx",
    "escalaPorcentajes": "0-100",
    "totalRegistros": 119,
    "nota": "Base de asistencia: exclusivamente los nombres que aparecen en la sección ‘a) Comité Central’ de las actas PDF. El cruce electoral se realizó con las candidaturas aceptadas de 2026. La asistencia 2026 corresponde a las actas disponibles hasta el 09/07/2026.",
    "criterio": "Porcentaje = asistencias ‘Sí’ / total de jornadas en que la persona figura formalmente en la sección a) Comité Central. ‘No’ y ‘No*’ cuentan como inasistencia; ‘No*’ corresponde a inasistencia avisada dentro del plazo reglamentario.",
    "fuenteCandidaturas2026": "candidaturas_aceptadas_elecciones_2026(1).xlsx",
    "criterioReeleccion2026": "Se marca como reelección cuando un nombre de la base de asistencia coincide con una candidatura aceptada en CC Nacional, Delegados Regionales, Representantes Regionales o Representantes de Frentes.",
    "totalReeleccion2026": 37,
    "notaCoincidencias2026": "Las coincidencias se normalizaron por mayúsculas, tildes y nombres compuestos. Nicole Román / Nicole Edibeth Romás Salas se conserva como coincidencia probable pendiente de revisión.",
    "fuenteResultados2026": "Boletín N°3 | Resultado de Calificación Comité Central - Elecciones Generales 2026",
    "totalReelectosElectos2026": 31,
    "totalReelectosNoElectos2026": 6,
    "criterioResultados2026": "Se cruzaron las candidaturas previamente identificadas como reelección con las personas electas publicadas en el Boletín N°3 del Tribunal Supremo.",
    "notaVotos2026": "CC Nacional: el boletín entrega votos por lista, no por integrante. Delegaciones y frentes: se muestran votos personales cuando están publicados. Representantes regionales: el boletín solo identifica a las personas electas y no informa votos individuales."
  },
  "registros": [
    {
      "nombre": "Alena Gutiérrez",
      "representacion2024": "Rep. RM",
      "porcentaje2024": 100,
      "porcentaje2025": 86.36,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 84.34,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Ana María Santos",
      "representacion2024": "Rep. Los Lagos",
      "porcentaje2024": 55.56,
      "porcentaje2025": 59.09,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 53.03,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Andrea Soto",
      "representacion2024": "Rep. Araucanía",
      "porcentaje2024": 77.78,
      "porcentaje2025": 90.91,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 78.45,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Andrés Giordano",
      "representacion2024": "Del. RM",
      "porcentaje2024": 77.78,
      "porcentaje2025": 90.91,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 82.15,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Antonia Orellana",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 54.55,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 55.22,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Armando Gacitúa",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 62.5,
      "porcentaje2026": 0,
      "promedioAniosDisponibles": 31.25,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Camila Castillo",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 71.72,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Camila Orellana",
      "representacion2024": "Rep. O’Higgins",
      "porcentaje2024": 83.33,
      "porcentaje2025": 81.82,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 88.38,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Camila Rojas",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 91.08,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Camila Romero",
      "representacion2024": "Del. Coquimbo",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 83.67,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Camila Tiznado",
      "representacion2024": "Del. FS",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Carla Amtmann",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 33.33,
      "porcentaje2025": 31.82,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 32.83,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Carla Andrea Amtmann Fecci",
          "tipo": "CC Nacional",
          "espacio": "Hacer Frente",
          "lista": "Hacer Frente",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 2073,
            "porcentajeVotos": 20.01,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Carla Retamal-Cofre",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": null,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Carolina Opazo",
      "representacion2024": "Rep. Biobío",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 89.44,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Caroline Sireau",
      "representacion2024": "Rep. Valparaíso",
      "porcentaje2024": 88.89,
      "porcentaje2025": 77.27,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 77.61,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Claudia Mix",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 44.44,
      "porcentaje2025": 77.27,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 66.5,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Claudia Nathalie Mix Jiménez",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Claudia Pedreros",
      "representacion2024": "Rep. Araucanía",
      "porcentaje2024": 44.44,
      "porcentaje2025": null,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 44.44,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Claudio Ferrada",
      "representacion2024": "Rep. Ñuble",
      "porcentaje2024": 66.67,
      "porcentaje2025": 90.91,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 67.34,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "CLAUDIO ANDRES FERRADA ALARCÓN",
          "tipo": "Representante regional",
          "espacio": "Ñuble",
          "region": "Ñuble",
          "lista": "PUENTES POR ÑUBLE",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Coca Ñanco",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 64.31,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Coca Ñanco Vásquez",
          "tipo": "CC Nacional",
          "espacio": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "lista": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3611,
            "porcentajeVotos": 34.86,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Constanza Cristi",
      "representacion2024": "Del. FES-NMD",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 92.59,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Constanza Schönhaut",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 72.73,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 64.98,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Constanza Gabriela Schonhaut Soto",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Dafne Pino",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 81.82,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 90.24,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Dafne Mabel Pino Riffo",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Daniela Campos",
      "representacion2024": "Rep. O’Higgins",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 94.78,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "David León",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 94.78,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "David Andrew León Reyes",
          "tipo": "CC Nacional",
          "espacio": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "lista": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3611,
            "porcentajeVotos": 34.86,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Diego Ibáñez",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 72.73,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 64.98,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Diego Eduardo Ibañez Cotroneo",
          "tipo": "Representante regional",
          "espacio": "Valparaíso",
          "region": "Valparaíso",
          "lista": "Valparaíso Avanza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Diego Soto",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Doris González",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 68.18,
      "porcentaje2026": 0,
      "promedioAniosDisponibles": 52.36,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Emilia Schneider",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 77.27,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 88.72,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Emilia Schneider Videla",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Erick Contreras",
      "representacion2024": "Rep. Ñuble",
      "porcentaje2024": 33.33,
      "porcentaje2025": 54.55,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 43.94,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Fabián Araneda",
      "representacion2024": "Rep. RM",
      "porcentaje2024": 100,
      "porcentaje2025": 86.36,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 91.75,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Fabián Lara",
      "representacion2024": "Del. FES-NMD",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 94.78,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "FABIAN ALONSO LARA MERCADO",
          "tipo": "Representante de frente",
          "espacio": "Ecosocial y NMD",
          "frente": "Ecosocial y NMD",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 71,
            "porcentajeVotos": null,
            "alcanceVotos": "persona",
            "nota": "Votación individual informada en el boletín."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Fernanda Betancourt",
      "representacion2024": "Rep. Maule",
      "porcentaje2024": 77.78,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 92.59,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Fernando Atria",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 22.22,
      "promedioAniosDisponibles": 67.34,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Fernando Atria Lemaitre",
          "tipo": "CC Nacional",
          "espacio": "Hacer Frente",
          "lista": "Hacer Frente",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 2073,
            "porcentajeVotos": 20.01,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Florencia Olate",
      "representacion2024": "Del. FE",
      "porcentaje2024": 77.78,
      "porcentaje2025": 86.36,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 80.64,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Francisca Gallegos",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 75.42,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Ana Francisca Gallegos Jara",
          "tipo": "Representante regional",
          "espacio": "Metropolitana",
          "region": "Metropolitana",
          "lista": "Construyendo El Futuro",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Francisca Márquez",
      "representacion2024": "Del. FTT",
      "porcentaje2024": 66.67,
      "porcentaje2025": 90.91,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 71.04,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Francisca Perales",
      "representacion2024": "Rep. Valparaíso",
      "porcentaje2024": 88.89,
      "porcentaje2025": 81.82,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 79.12,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Francisca Perales",
          "tipo": "CC Nacional",
          "espacio": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "lista": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3611,
            "porcentajeVotos": 34.86,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Francisco Arellano",
      "representacion2024": "Rep. RM",
      "porcentaje2024": 100,
      "porcentaje2025": 90.91,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 96.97,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Francisco Javier Arellano Rojas",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Francisco Yeber",
      "representacion2024": "Del. Ñuble",
      "porcentaje2024": 88.89,
      "porcentaje2025": 86.36,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 80.64,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gabriel González",
      "representacion2024": "Rep. Maule",
      "porcentaje2024": 77.78,
      "porcentaje2025": 86.36,
      "porcentaje2026": 22.22,
      "promedioAniosDisponibles": 62.12,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gabriel Rojas",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 90.91,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 89.56,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gabriela Carrasco",
      "representacion2024": "Rep. Antofagasta",
      "porcentaje2024": 77.78,
      "porcentaje2025": 59.09,
      "porcentaje2026": 37.5,
      "promedioAniosDisponibles": 58.12,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gabriela Izquierdo",
      "representacion2024": "Del. FEC",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 83.67,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gael Yeomans",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 68.18,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 67.17,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Giorgio Boccardo",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 77.78,
      "porcentaje2025": 63.64,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 76.77,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Giorgio Jackson",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 72.73,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 57.58,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gonzalo Oyarzún",
      "representacion2024": "Del. FEC",
      "porcentaje2024": 100,
      "porcentaje2025": 90.91,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 93.27,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Gonzalo Winter",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 77.78,
      "porcentaje2025": 54.55,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 58.92,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Humberto Quezada",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 63.13,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "HUMBERTO QUEZADA MARTEL",
          "tipo": "Representante regional",
          "espacio": "La Araucanía",
          "region": "La Araucanía",
          "lista": "UNIDAD PARA AVANZAR",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Ignacio Achurra",
      "representacion2024": "Del. FC",
      "porcentaje2024": 77.78,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 68.01,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Ignacio Jaime Achurra Díaz",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Iván Zimmermann",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 86.36,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 88.05,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Jaime Bassa",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 77.78,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 92.59,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Jaime Andres Bassa Mercado",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Jaime Figueroa",
      "representacion2024": "Rep. Los Lagos",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 94.78,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Jaime Sáez",
      "representacion2024": "Rep. Los Lagos",
      "porcentaje2024": 55.56,
      "porcentaje2025": 68.18,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 63.47,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Jason Cabezas",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Javier Inostroza",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": null,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Javier Ignacio Inostroza Castillo",
          "tipo": "Representante regional",
          "espacio": "Biobío",
          "region": "Biobío",
          "lista": "Desde los territorios al Comité Central",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Javiera Cabello",
      "representacion2024": "Del. FF",
      "porcentaje2024": 100,
      "porcentaje2025": 81.82,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 82.83,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Javiera Carlesi",
      "representacion2024": "Del. FE",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 93.27,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Javiera López",
      "representacion2024": "Rep. RM",
      "porcentaje2024": 88.89,
      "porcentaje2025": 86.36,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 88.05,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Javiera Paz López Latana",
          "tipo": "CC Nacional",
          "espacio": "Hacer Frente",
          "lista": "Hacer Frente",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 2073,
            "porcentajeVotos": 20.01,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Javiera Morales",
      "representacion2024": "Del. Magallanes",
      "porcentaje2024": 77.78,
      "porcentaje2025": 100,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 81.48,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Javiera Toro",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 66.67,
      "porcentaje2025": 72.73,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 64.98,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Javiera Alejandra Toro Cáceres",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Javiera Vivanco",
      "representacion2024": "Del. FS",
      "porcentaje2024": 88.89,
      "porcentaje2025": 100,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 85.19,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Javiera del Pilar Vivanco Escobar",
          "tipo": "Representante de frente",
          "espacio": "Salud",
          "frente": "Salud",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 49,
            "porcentajeVotos": null,
            "alcanceVotos": "persona",
            "nota": "Votación individual informada en el boletín."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Jenny Rojas",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": null,
      "porcentaje2026": 80,
      "promedioAniosDisponibles": 80,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Jenny Fernanda Rojas Muñoz",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Juan José Moreno",
      "representacion2024": "Del. Atacama",
      "porcentaje2024": 88.89,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 96.3,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Juan José Muñoz",
      "representacion2024": "Del. Biobío",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 14.29,
      "promedioAniosDisponibles": 69.91,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Juan Pablo Sanhueza",
      "representacion2024": "Rep. Biobío",
      "porcentaje2024": 44.44,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 76.26,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Karina Cartagena",
      "representacion2024": "Rep. Maule",
      "porcentaje2024": 66.67,
      "porcentaje2025": 81.82,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 79.12,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Kevyn Galleguillos",
      "representacion2024": "Del. Antofagasta",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 85.86,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Kinturay Melín",
      "representacion2024": "Del. Araucanía",
      "porcentaje2024": 88.89,
      "porcentaje2025": 100,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 92.59,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Leonardo Baño",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 72.73,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 72.73,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Leonardo Jofré",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 91.08,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Leslie Gallegos",
      "representacion2024": "Rep. Arica",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 98.48,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "LESLIE FERNANDO GALLEGOS GALLARDO",
          "tipo": "Representante regional",
          "espacio": "Arica y Parinacota",
          "region": "Arica y Parinacota",
          "lista": "Voluntad colectiva",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Libertad Vidal",
      "representacion2024": "Del. FF",
      "porcentaje2024": 88.89,
      "porcentaje2025": 100,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 92.59,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Lorena Meneses",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 89.56,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Lorena Meneses Quiroz",
          "tipo": "CC Nacional",
          "espacio": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "lista": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3611,
            "porcentajeVotos": 34.86,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Luis Llaulén",
      "representacion2024": "Del. FTT",
      "porcentaje2024": 66.67,
      "porcentaje2025": 81.82,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 71.72,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Luis Alejandro Llaulen castro",
          "tipo": "Representante de frente",
          "espacio": "Trabajadores y Trabajadoras",
          "frente": "Trabajadores y Trabajadoras",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 62,
            "porcentajeVotos": null,
            "alcanceVotos": "persona",
            "nota": "Votación individual informada en el boletín."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Luz Bermúdez",
      "representacion2024": "Rep. Magallanes",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 91.08,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Magda Cottet",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 89.56,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Marco Ávila",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 86.36,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 84.34,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Margarita Crespo",
      "representacion2024": "Del. O'Higgins",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 82.15,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Margarita González",
      "representacion2024": "Rep. Coquimbo",
      "porcentaje2024": 77.78,
      "porcentaje2025": 86.36,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 65.82,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Margarita Catalina Gonzalez Avalos",
          "tipo": "Representante regional",
          "espacio": "Coquimbo",
          "region": "Coquimbo",
          "lista": "Somos Unidad en Acción",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Marisol Garcés",
      "representacion2024": "Del. TI",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "MARISOL AGUSTINA GARCÉS VERGARA",
          "tipo": "Delegado/a regional",
          "espacio": "Rep. Territorio Internacional",
          "region": "Rep. Territorio Internacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín no informa la votación de esta candidatura no electa."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Marjorie Farías",
      "representacion2024": "Rep. Valparaíso",
      "porcentaje2024": 88.89,
      "porcentaje2025": 77.27,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 73.91,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Martín Cartes",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": null,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "María Angélica Ibáñez",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 94.78,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Matías Fernández",
      "representacion2024": "Rep. Los Ríos",
      "porcentaje2024": 100,
      "porcentaje2025": 81.82,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 86.53,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Matias José Fernández Hartwig",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Matías Álvarez",
      "representacion2024": "Rep. Aysén",
      "porcentaje2024": 87.5,
      "porcentaje2025": 100,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 93.75,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Miguel Bustamante",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 77.78,
      "porcentaje2025": 86.36,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 76.94,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Miguel Ángel Bustamante Araneda",
          "tipo": "Representante de frente",
          "espacio": "Trabajadores y Trabajadoras",
          "frente": "Trabajadores y Trabajadoras",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 54,
            "porcentajeVotos": null,
            "alcanceVotos": "persona",
            "nota": "Votación individual informada en el boletín."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Miguel Maugard",
      "representacion2024": "Del. Arica",
      "porcentaje2024": 66.67,
      "porcentaje2025": 90.91,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 85.86,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Natalia Sánchez",
      "representacion2024": "Rep. RM",
      "porcentaje2024": 88.89,
      "porcentaje2025": 95.45,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 91.08,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Nataly Campusano",
      "representacion2024": "Del. Valparaíso",
      "porcentaje2024": 66.67,
      "porcentaje2025": 72.73,
      "porcentaje2026": 22.22,
      "promedioAniosDisponibles": 53.87,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Natividad Manqui",
      "representacion2024": "Rep. Los Ríos",
      "porcentaje2024": 88.89,
      "porcentaje2025": 86.36,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 91.75,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Natividad de la Concepción Manqui Manqui",
          "tipo": "Representante regional",
          "espacio": "Los Ríos",
          "region": "Los Ríos",
          "lista": "Más territorio, más Frente Amplio",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Nicole Pérez",
      "representacion2024": "Rep. Coquimbo",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 89.56,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Nicole Fernanda Pérez Rojas",
          "tipo": "Delegado/a regional",
          "espacio": "Coquimbo",
          "region": "Coquimbo",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 303,
            "porcentajeVotos": 71.13,
            "alcanceVotos": "persona",
            "nota": "Votación individual informada en el boletín."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Nicole Román",
      "representacion2024": "Del. Maule",
      "porcentaje2024": 88.89,
      "porcentaje2025": 86.36,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 88.05,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Nicole Edibeth Romás Salas",
          "tipo": "Representante regional",
          "espacio": "Maule",
          "region": "Maule",
          "lista": "Unidad para el Maule",
          "confianzaCoincidencia": "probable",
          "notaCoincidencia": "Revisar diferencia de apellido entre la asistencia (Román) y la candidatura (Romás).",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Nicolás Lara",
      "representacion2024": "Rep. Coquimbo",
      "porcentaje2024": 100,
      "porcentaje2025": 90.91,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 89.56,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Nicolás Quilodrán",
      "representacion2024": "Del. Aysén",
      "porcentaje2024": 87.5,
      "porcentaje2025": 100,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 93.75,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Noemí Salinas",
      "representacion2024": "Rep. Tarapacá",
      "porcentaje2024": 100,
      "porcentaje2025": 77.27,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 81.31,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Paloma Zúñiga",
      "representacion2024": "Rep. Biobío",
      "porcentaje2024": 88.89,
      "porcentaje2025": 77.27,
      "porcentaje2026": 11.11,
      "promedioAniosDisponibles": 59.09,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Pelayo Vial",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": null,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Pelayo Ignacio Vial González",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Pilar Gajardo",
      "representacion2024": "Del. FC",
      "porcentaje2024": 77.78,
      "porcentaje2025": 90.91,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 71.04,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Reynaldo Zumarán",
      "representacion2024": "Rep. Tarapacá",
      "porcentaje2024": 55.56,
      "porcentaje2025": 63.64,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 50.84,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Roberto Arenas",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 90.91,
      "porcentaje2026": 50,
      "promedioAniosDisponibles": 80.3,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Rocío Palominos",
      "representacion2024": "Rep. Antofagasta",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 96.3,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Rodri Mallea",
      "representacion2024": "Del. FDDSG",
      "porcentaje2024": 100,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Rodri Mallea Cardemil",
          "tipo": "CC Nacional",
          "espacio": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "lista": "Unidad para Avanzar: Defendamos Chile con Firmeza",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3611,
            "porcentajeVotos": 34.86,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Rodrigo Echecopar",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 72.73,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 76.09,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Rodrigo Leiva",
      "representacion2024": "Del. Los Ríos",
      "porcentaje2024": 88.89,
      "porcentaje2025": 95.45,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 79.97,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Rodrigo Itvan Leiva Caro",
          "tipo": "Representante regional",
          "espacio": "Los Ríos",
          "region": "Los Ríos",
          "lista": "Integración Regional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": false,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "no_electo"
    },
    {
      "nombre": "Rodrigo Mansilla",
      "representacion2024": "Del. Los Lagos",
      "porcentaje2024": 88.89,
      "porcentaje2025": 81.82,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 82.83,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Roger Ancamil",
      "representacion2024": "Rep. Araucanía",
      "porcentaje2024": 88.89,
      "porcentaje2025": 81.82,
      "porcentaje2026": 88.89,
      "promedioAniosDisponibles": 86.53,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Romina Cejas",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 100,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 100,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Romina Ramos",
      "representacion2024": "Del. Tarapacá",
      "porcentaje2024": 100,
      "porcentaje2025": 72.73,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 83.5,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Romina Carolina Ramos Rodr´guez",
          "tipo": "Representante regional",
          "espacio": "Tarapacá",
          "region": "Tarapacá",
          "lista": "Norte Social",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": null,
            "porcentajeVotos": null,
            "alcanceVotos": "no_informado",
            "nota": "El boletín publica las personas electas por región, pero no informa votos individuales."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    },
    {
      "nombre": "Rubén Andino",
      "representacion2024": "Rep. O’Higgins",
      "porcentaje2024": 83.33,
      "porcentaje2025": 95.45,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 92.93,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Sebastián Artiaga",
      "representacion2024": "Rep. Biobío",
      "porcentaje2024": 88.89,
      "porcentaje2025": 81.82,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 71.72,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Sebastián Villarroel",
      "representacion2024": "Rep. Valparaíso",
      "porcentaje2024": 55.56,
      "porcentaje2025": 95.45,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 68.86,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Tatiana Urrutia",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 90.91,
      "porcentaje2026": 44.44,
      "promedioAniosDisponibles": 74.75,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Tomás Garay",
      "representacion2024": "Rep. Atacama",
      "porcentaje2024": 100,
      "porcentaje2025": 95.45,
      "porcentaje2026": 55.56,
      "promedioAniosDisponibles": 83.67,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Valeria Cárcamo",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 95.45,
      "porcentaje2026": 77.78,
      "promedioAniosDisponibles": 87.37,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Ximena Peralta",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 88.89,
      "porcentaje2025": 68.18,
      "porcentaje2026": 33.33,
      "promedioAniosDisponibles": 63.47,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Yerko Ljubetic",
      "representacion2024": "Rep. nacional",
      "porcentaje2024": 100,
      "porcentaje2025": 43.75,
      "porcentaje2026": null,
      "promedioAniosDisponibles": 71.88,
      "observacion": null,
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Yoal Díaz",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 100,
      "porcentaje2026": 100,
      "promedioAniosDisponibles": 100,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": false,
      "candidaturas2026": [],
      "resultadoReeleccion2026": null
    },
    {
      "nombre": "Óscar Aguilera",
      "representacion2024": null,
      "porcentaje2024": null,
      "porcentaje2025": 100,
      "porcentaje2026": 66.67,
      "promedioAniosDisponibles": 83.33,
      "observacion": "2026 parcial hasta 09-jul",
      "vaReeleccion2026": true,
      "candidaturas2026": [
        {
          "nombreCompleto": "Oscar Eduardo Aguilera Ruiz",
          "tipo": "CC Nacional",
          "espacio": "Esperanza Socialista - CC Nacional",
          "lista": "Esperanza Socialista - CC Nacional",
          "confianzaCoincidencia": "exacta",
          "resultado2026": {
            "electo": true,
            "votos": 3512,
            "porcentajeVotos": 33.91,
            "alcanceVotos": "lista",
            "nota": "El boletín informa la votación de la lista, no votos individuales de sus integrantes."
          }
        }
      ],
      "resultadoReeleccion2026": "electo"
    }
  ]
}
